import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
import { getBaseValue, KpiReport } from "../processors";
import { getKpisForProvidersWithCategoryChart } from "../../Components/opendata";
import { EMPTY_ARRAY, getFigureAndSolidDashGraph } from "../../Components/misc";
import _ from "lodash";
import { FigureSolidDashKpiProvider } from "./categoryChartData.types";

export const getWaterSuppliedPerResidentialConnection = (
    kpis: string[][],
    yearBasedResults: KpiReport[]
): KpiReport => {
    if (!kpis || kpis?.length === 0 || !yearBasedResults || yearBasedResults?.length === 0) return {} as KpiReport;

    const numerKpi = kpis?.[0]?.[0];
    const denoKpis = kpis
        .filter((__, index) => index !== 0)
        .map(d => d?.[0])
        .filter(d => d != null);

    if (!numerKpi || !denoKpis) return {} as KpiReport;

    const denoKpisMap = denoKpis.reduce((prev, cur) => {
        prev[cur] = 1;
        return prev;
    }, {});

    const denoResults = yearBasedResults.filter(d => denoKpisMap[d.kpiCode] === 1);
    let numerResult = yearBasedResults.find(d => d.kpiCode === numerKpi);

    if (numerResult?.value == null || !denoResults?.length) return {} as KpiReport;

    const baseUnit = getBaseValue(0, numerResult?.unit)?.unit;
    // const unit = roundValue(0, baseUnit)?.unit as Unit;

    const denoKpiSumValue = _.sum(
        denoResults?.map(res => getBaseValue(res?.value ?? 0, res?.unit)?.value ?? 0) ?? EMPTY_ARRAY
    );
    if (denoKpiSumValue == null || denoKpiSumValue === 0) {
        return {
            ...numerResult,
            indicatorTitle: "",
            comment: null,
            kpiCode: null,
            value: null,
            unit: baseUnit
        };
    }

    const baseValue = getBaseValue(numerResult?.value, numerResult?.unit)?.value / denoKpiSumValue;

    // const value = roundValue(baseValue, baseUnit)?.value;

    return {
        ...numerResult,
        indicatorTitle: "",
        comment: null,
        kpiCode: null,
        value: baseValue,
        unit: baseUnit
    };
};

export const fetchFigureWaterSuppliedPerResidentialConnectionChartData: CategoryChartQueryFn = async ({
    metadata,
    categoryChart,
    providers,
    kpis,
    category
}: CategoryChartQueryParam): Promise<FigureSolidDashKpiProvider> => {
    const provider = providers?.[0];

    if (!metadata || !providers || providers?.length === 0 || !categoryChart || !kpis || kpis?.length === 0)
        return null;

    let kpiReportResults = await getKpisForProvidersWithCategoryChart(kpis, [provider], true, categoryChart);

    kpiReportResults = (kpiReportResults ?? []).filter(d => d != null && d.provider != null);

    const rec = getFigureAndSolidDashGraph(
        metadata,
        provider,
        kpiReportResults,
        kpis,
        categoryChart,
        category,
        "%",
        getWaterSuppliedPerResidentialConnection
    );

    // const rec = getFigureAndGraphForOperatingSurplusRatio(kpiReportResults, provider, kpis, categoryChart, category);

    if (!rec) return null;

    const { figure, graph, unit, year } = rec;
    return {
        unit,
        year,
        waterProvider: provider,
        kpiCode: null,
        schemeType: kpis?.[0]?.[1],
        title: categoryChart?.displayTitle,
        footer: null,
        figure,
        graph
    };
};
